import { Download01Icon } from "Icons/Download01";

import { useEffect, useRef, useState } from "react";

import { css } from "@emotion/react";

import Link from "next/link";
import { useRouter } from "next/router";

import { Disclaimer } from "components/shared/library/Disclaimer";

import { useAccount } from "contexts/AccountContext";

import { isRibbonExtensionInstalled } from "utils/externals";
import { isViewMobile } from "utils/mediaQueryStrings";
import { getExternalChromeExtensionUrl, getProfileUrl } from "utils/urls";

const style = {
  hidden: css({ display: "hidden" }),
};

export const JobsCXWidget = () => {
  const [showExtensionButton, setShowExtensionButton] = useState(false);
  const linkRef = useRef<HTMLAnchorElement>(null);
  const { accountProfile } = useAccount(true);
  const router = useRouter();
  useEffect(() => {
    isRibbonExtensionInstalled().then((isInstalled) => {
      if (!isInstalled && !isViewMobile()) {
        setShowExtensionButton(true);
      }
    });
  }, []);

  return (
    <>
      <Disclaimer
        title={
          showExtensionButton
            ? "A smarter, faster way to job search"
            : "Better recommendations and advice"
        }
        subtitle={
          showExtensionButton
            ? "Just add Copilot to your browser and let Ribbon keep you in the loop. It learns about your current interests to boost your job search with better recommendations and advice."
            : "The more you use Ribbon (and the more updated your profile) the better results you'll get."
        }
        type="info"
        isDismissible
        primaryButtonProps={
          showExtensionButton
            ? {
                children: "Download Chrome extension",
                IconLeft: Download01Icon,
                onClick: () => linkRef.current?.click(),
              }
            : undefined
        }
        secondaryButtonProps={{
          children: "Update profile",
          background: "outlined",
          onClick: () => router.push(getProfileUrl(accountProfile.handle)),
        }}
      ></Disclaimer>
      <Link
        ref={linkRef}
        target="_blank"
        href={getExternalChromeExtensionUrl()}
        css={style.hidden}
      />
    </>
  );
};
